// Author : NANDHAKUMAR
// Version :0.0.1
// MODIFIED DATE: 14/11/2025
const FixedDepositActionTypes = {
	/** ***************** GET FIXED DEPOSIT DETAILS START *********************** */
	GET_FIXED_DEPOSIT_DETAILS_START: 'get_fixed_deposit_details_start',
	GET_FIXED_DEPOSIT_DETAILS_SUCCESS: 'get_fixed_deposit_details_success',
	GET_FIXED_DEPOSIT_DETAILS_FAILURE: 'get_fixed_deposit_details_failure',
	GET_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET: 'get_fixed_deposit_details_response_reset',
	GET_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED: 'get_fixed_deposit_details_response_changed',
	/** ***************** GET FIXED DEPOSIT DETAILS END *********************** */

	/** ***************** ADD FIXED DEPOSIT DETAILS START *********************** */
	ADD_FIXED_DEPOSIT_DETAILS_START: 'add_fixed_deposit_details_start',
	ADD_FIXED_DEPOSIT_DETAILS_SUCCESS: 'add_fixed_deposit_details_success',
	ADD_FIXED_DEPOSIT_DETAILS_FAILURE: 'add_fixed_deposit_details_failure',
	ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET: 'add_fixed_deposit_details_response_reset',
	ADD_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED: 'add_fixed_deposit_details_response_changed',
	/** ***************** ADD FIXED DEPOSIT DETAILS END *********************** */

	/** ***************** DELETE FIXED DEPOSIT DETAILS START *********************** */
	DELETE_FIXED_DEPOSIT_DETAILS_START: 'delete_fixed_deposit_details_start',
	DELETE_FIXED_DEPOSIT_DETAILS_SUCCESS: 'delete_fixed_deposit_details_success',
	DELETE_FIXED_DEPOSIT_DETAILS_FAILURE: 'delete_fixed_deposit_details_failure',
	DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_RESET: 'delete_fixed_deposit_details_response_reset',
	DELETE_FIXED_DEPOSIT_DETAILS_RESPONSE_CHANGED: 'delete_fixed_deposit_details_response_changed',
	/** ***************** DELETE FIXED DEPOSIT DETAILS END *********************** */

	/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE DETAILS START *********************** */
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_START:
		'fetch_fixed_deposit_collction_approval_details_start',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_SUCCESS:
		'fetch_fixed_deposit_collction_approval_details_success',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_FAILURE:
		'fetch_fixed_deposit_collction_approve_details_failure',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_RESET:
		'fetch_fixed_deposit_collction_approve_details_response_reset',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVAL_DETAILS_RESPONSE_CHANGED:
		'fetch_fixed_deposit_collction_approve_details_response_changed',
	/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVAL DETAILS END *********************** */

	/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS START *********************** */
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_START:
		'fetch_fixed_deposit_collction_approve_eod_details_start',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_SUCCESS:
		'fetch_fixed_deposit_collction_approve_eod_details_success',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_FAILURE:
		'fetch_fixed_deposit_collction_approve_eod_details_failure',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_RESET:
		'fetch_fixed_deposit_collction_approve_eod_details_response_reset',
	FETCH_FIXED_DEPOSIT_COLLCTION_APPROVE_EOD_DETAILS_RESPONSE_CHANGED:
		'fetch_fixed_deposit_collction_approve_eod_details_response_changed',
	/** ***************** FETCH FIXED DEPOSIT COLLCTION APPROVE EOD DETAILS END *********************** */
};
export default FixedDepositActionTypes;
